<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-input
            placeholder="名称查找"
            @change="changeSearchText"
            style="width:150px"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            placeholder="请选择企业"
            @change="changeEnterpriseSearch"
            style="width:180px"
          >
            <a-select-option value="">
              全部企业
            </a-select-option>
            <a-select-option
              v-for="item in enterpriseList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            @click="searchList"
          >
            <a-icon type="search" />
            查询
          </a-button>
          &emsp;
        </a-form-item>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      :loading="tableLoading"
    >
      <a slot-scope="name" slot="name">{{ name }}</a>
      <!-- 身份证号 -->
      <a-tag color="green" slot-scope="text" slot="idNumber">{{ text }}</a-tag>
      <!-- 姓名 -->
      <template slot-scope="sex" slot="sex">
        <a-icon type="man" style="color:green" v-if="sex === 1" />
        <a-icon type="woman" style="color:red" v-if="sex === 0" />
      </template>
      <!-- 状态 -->
      <template slot="isEnable" slot-scope="isEnable">
        <span v-if="isEnable" style="color: green;">
          <a-icon type="unlock" />&nbsp;启用
        </span>
        <span v-if="!isEnable" style="color: red;">
          <a-icon type="lock" />&nbsp;停用
        </span>
      </template>
    </a-table>
  </div>
</template>
<script>
import { getWorkerList } from '@/apis/user'
import { getEnterpriseDropdownList } from '@/apis/enterprise'

const columns = [{
  title: '姓名',
  dataIndex: 'name',
  key: 'name',
  scopedSlots: { customRender: 'name' }
}, {
  title: '企业',
  dataIndex: 'enterprise',
  key: 'enterprise'
}, {
  title: '工号',
  dataIndex: 'number',
  key: 'number'
}, {
  title: '职位',
  key: 'job',
  dataIndex: 'job'
}, {
  title: '身份证号',
  key: 'idNumber',
  dataIndex: 'idNumber',
  scopedSlots: { customRender: 'idNumber' }
}, {
  title: '联系电话',
  key: 'phone',
  dataIndex: 'phone'
}, {
  title: '性别',
  key: 'sex',
  dataIndex: 'sex',
  scopedSlots: { customRender: 'sex' }
}, {
  title: '状态',
  key: 'state',
  dataIndex: 'state',
  scopedSlots: { customRender: 'isEnable' }
}, {
  title: '创建时间',
  key: 'createTime',
  dataIndex: 'createTime'
}]

export default {
  data () {
    return {
      tableData: [],
      columns,
      tableLoading: false,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._getEnterpriseList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this._getEnterpriseList()
        }
      },
      searchText: '',
      searchEnterpriseId: '',
      enterpriseList: []
    }
  },

  methods: {

    // 检索
    changeSearchText (e) {
      this.searchText = e.target.value
    },
    searchList () {
      this.pagination.current = 1
      this._getEnterpriseList()
    },
    changeEnterpriseSearch (value) {
      this.searchEnterpriseId = value
    },
    // 获取企业列表
    _getEnterpriseList () {
      this.tableLoading = true
      getWorkerList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        search: this.searchText,
        companyId: this.searchEnterpriseId
      }).then(res => {
        const result = res.data.attribute
        this.pagination.total = result.count

        this.tableData = result.rows.map(item => ({
          key: item.createTime,
          name: item.name,
          enterprise: item.companyName,
          number: item.number,
          job: item.job,
          idNumber: item.idNumber,
          phone: item.phone,
          sex: item.sex,
          createTime: item.createTime.split('T')[0] + ' ' + item.createTime.split('T')[1].split('.')[0],
          state: item.isEnable
        }))

        this.tableLoading = false
      })
    },
    // 获取企业下拉
    _getEnterpriseDropdownList () {
      getEnterpriseDropdownList().then(res => {
        this.enterpriseList = res.data.attribute
      })
    }
  },

  created () {
    this._getEnterpriseList()
    this._getEnterpriseDropdownList()
  }

}
</script>
<style lang="less" scoped>
</style>
